import { render, staticRenderFns } from "./RenewToken.vue?vue&type=template&id=6be417e4"
import script from "./RenewToken.vue?vue&type=script&lang=js"
export * from "./RenewToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports